import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

export const TennisIcon = observer('TennisIcon', ({ className, onClick }: PropsType): JSX.Element => {
    return (
        <SvgElement
            width='24'
            height='24'
            viewBox='0 0 24 24'
            xmlns='http://www.w3.org/2000/svg'
            fill='#061A32'
            className={className}
            onClick={onClick}
        >
            <path
                d='M11.1475 2.94417C9.11355 3.13384 7.12805 4.00932 5.56763 5.56886C4.0072 7.12794 3.13261 9.11345 2.94338 11.15C5.17674 11.409 7.55136 12.5506 9.50088 14.5001C11.4513 16.4501 12.5942 18.8264 12.8509 21.058C14.8906 20.8688 16.8712 19.9938 18.433 18.4351C19.993 16.8765 20.8667 14.8901 21.055 12.8539C18.827 12.5954 16.4484 11.4539 14.4989 9.50389C12.5507 7.55436 11.4078 5.17753 11.1475 2.94417Z'
                fill='fill'
            />
            <path
                d='M21.0913 11.7262C21.0252 9.48969 20.1403 7.27409 18.4356 5.56709C16.7299 3.86009 14.5116 2.97838 12.2752 2.90909C12.5266 4.86217 13.5637 6.96094 15.3023 8.69993C17.0408 10.4389 19.1369 11.4743 21.0913 11.7262Z'
                fill='fill'
            />
            <path
                d='M2.90998 12.2769C2.97572 14.5125 3.86098 16.7286 5.56754 18.4347C7.27276 20.1399 9.48836 21.026 11.7244 21.0909C11.473 19.1405 10.4371 17.043 8.69771 15.3041C6.96006 13.566 4.86173 12.5301 2.90998 12.2769Z'
                fill='fill'
            />
        </SvgElement>
    );
});
